export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderErrorCode@2x.png";